import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { BalanceInfo } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: BalanceInfo[];
  ccy?: BackportingEnums.CcyEnum;
  showConversionRate?: boolean;
}

const FIRST_TABLE_FIELDS = [
  // 'consolidation',
  'reportingPeriod',
  'currencyOfAccounts',
];
const CONVERSION_TABLE_FIELDS: string[] = [
  'currencyConversion',
  'currencyConversionRate',
  // 'empty',
];
const REMAINING_TABLE_FIELDS = [
  'fixedAssets',
  'intangibleFixedAssets',
  'tangibleFixedAssets',
  'otherFixedAssets',
  'currentAssets',
  'stock',
  'debtors',
  'otherCurrentAssets',
  'cashAndCashEquivalents',
  'totalAssets',
  'shareholdersFunds',
  'shareCapital',
  'otherShareholdersFunds',
  'nonCurrentLiabilities',
  'longTermDebt',
  'otherNonCurrentLiabilities',
  'provisions',
  'currentLiabilities',
  'shortTermLoans',
  'creditors',
  'otherCurrentLiabilities',
  'totalShareholdersFundsAndLiabilities',
];

const FinancialsBalanceSheet: React.FC<Props> = ({ data, ccy, showConversionRate }) => {
  const tableFields = showConversionRate
    ? FIRST_TABLE_FIELDS.concat(CONVERSION_TABLE_FIELDS).concat(REMAINING_TABLE_FIELDS)
    : FIRST_TABLE_FIELDS.concat(REMAINING_TABLE_FIELDS);
  return (
    <MatrixDataTable
      title={'balanceSheet'}
      translationsScope={'companies:companyFinancials'}
      data={data}
      tableFields={tableFields}
      showCurrency={false}
      ccy={ccy}
    />
  );
};

export default FinancialsBalanceSheet;
